import script from "./form-action.vue?vue&type=script&lang=ts&setup=true&name=FormAction"
export * from "./form-action.vue?vue&type=script&lang=ts&setup=true&name=FormAction"

const __exports__ = script;

export default __exports__